import React from 'react'
import styled from 'styled-components'

interface PropsType {
  width?: string | number
  height?: string | number
  title?: string
  className?: string
  children: React.ReactNode
}

const Icon = styled.svg`
  fill: currentColor;
`

const IconBase = (props: PropsType) => {
  const { width = 100, height = 100, title = 'icon', className, children } = props
  return (
    <Icon xmlns="http://www.w3.org/2000/svg" width={width} height={height} className={className} viewBox="0 0 600 600">
      <title>{title}</title>
      {children}
    </Icon>
  )
}

export default IconBase
